import type { TourDefinition } from '@renderer/hooks/useTour';

/**
 * Sprint 9.1 — Tour del Dashboard.
 * Sprint 26 — Actualizado tras Sprint 23.2/25.
 * Sprint 31 — Reorganizado: el "checklist de apertura" y el "resumen del día"
 * se reemplazaron por la franja de estado y la card de pedidos en curso. El
 * paso de precarga sólo aparece cuando la card está visible (lógica del driver).
 */
export const tourDashboard: TourDefinition = {
  id: 'dashboard',
  title: 'Cómo usar el Dashboard',
  steps: [
    {
      element: '[data-tour="dsh-ctas"]',
      popover: {
        title: '1. Acciones rápidas',
        description:
          'Los botones grandes te llevan a lo principal: vender comer aquí o a domicilio, y ver los pedidos del día. Empieza por aquí cada turno.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="dsh-precarga"]',
      popover: {
        title: '2. Precargar inventario (en la mañana)',
        description:
          'Si hay sugerencias de carga basadas en lo vendido ayer, aparece este aviso ámbar. Tócalo y el sistema te sugiere cuánto cargar de cada insumo.',
        side: 'bottom',
      },
    },
    {
      element: '[data-tour="dsh-estado"]',
      popover: {
        title: '3. Cómo va el día',
        description:
          'Las ventas de hoy de un vistazo. Los recuadros verdes confirman que la caja está abierta y el inventario en orden; si algo necesita atención, aparece una alerta más arriba.',
        side: 'top',
      },
    },
    {
      element: '[data-tour="dsh-pedidos"]',
      popover: {
        title: '4. Pedidos en curso',
        description:
          'El pulso del momento: cuántos pedidos están en cocina, listos, en ruta o esperando cobro — separados entre comer aquí y a domicilio. Toca un recuadro para ir a operarlo.',
        side: 'top',
      },
    },
    {
      element: '[data-tour="dsh-mesas"]',
      popover: {
        title: '5. Estado del salón',
        description:
          'Vista en tiempo real de todas las mesas. Verde = disponible, naranja = ocupada, gris = fuera de servicio. Se actualiza sola cada 5 segundos.',
        side: 'top',
      },
    },
  ],
};
